if ( objects.is_front_page ) {
  // jQuery.fn.isInViewport = function () {
  //   let elementTop = jQuery(this).offset().top;
  //   let elementBottom = (elementTop + jQuery(this).outerHeight()) - 150;

  //   let viewportTop = jQuery(window).scrollTop();
  //   let viewportBottom = (viewportTop + jQuery(window).height()) - 700;

  //   return elementBottom > viewportTop && elementTop < viewportBottom;
  // };

  // jQuery(window).on('resize scroll', function() {
  //   if (jQuery('#nos-offres').isInViewport()) {
  //     jQuery('.nav-offres').addClass('active');
  //   } else {
  //     jQuery('.nav-offres').removeClass('active');
  //   }

  //   if (jQuery('#nos-offres').isInViewport()) {
  //     jQuery('.nav-offres').addClass('active');
  //   } else {
  //     jQuery('.nav-offres').removeClass('active');
  //   }
  
  //   if (jQuery('#notre-approche').isInViewport()) {
  //     jQuery('.nav-approche').addClass('active');
  //   } else {
  //     jQuery('.nav-approche').removeClass('active');
  //   }
  
  //   if (jQuery('#nos-valeurs').isInViewport()) {
  //     jQuery('.nav-valeurs').addClass('active');
  //   } else {
  //     jQuery('.nav-valeurs').removeClass('active');
  //   }
  
  //   if (jQuery('#notre-equipe').isInViewport()) {
  //     jQuery('.nav-equipe').addClass('active');
  //   } else {
  //     jQuery('.nav-equipe').removeClass('active');
  //   }
  // });

  // if (jQuery('#nos-offres').isInViewport()) {
  //   jQuery('.nav-offres').addClass('active');
  // } else {
  //   jQuery('.nav-offres').removeClass('active');
  // }

  // if (jQuery('#notre-approche').isInViewport()) {
  //   jQuery('.nav-approche').addClass('active');
  // } else {
  //   jQuery('.nav-approche').removeClass('active');
  // }

  // if (jQuery('#nos-valeurs').isInViewport()) {
  //   jQuery('.nav-valeurs').addClass('active');
  // } else {
  //   jQuery('.nav-valeurs').removeClass('active');
  // }

  // if (jQuery('#notre-equipe').isInViewport()) {
  //   jQuery('.nav-equipe').addClass('active');
  // } else {
  //   jQuery('.nav-equipe').removeClass('active');
  // }

  const swiper_home = new Swiper('.swiper-home', {
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
      delay: 5000,
    }
  });

  swiper_home.on('slideChange', function () {
    const index_currentSlide = swiper_home.realIndex;

    if ( index_currentSlide == 0) {
      jQuery( "#play1" ).trigger( "click" );
    } else if ( index_currentSlide == 1) {
      jQuery( "#play2" ).trigger( "click" );
    } else if ( index_currentSlide == 2) {
      jQuery( "#play3" ).trigger( "click" );
    }
  });

  //register the plugin (just once)
  gsap.registerPlugin(MotionPathPlugin);

  gsap.set(".boat", {autoAlpha: 1});

  var tl = gsap.timeline({});

  tl.to(".boat", {
    duration: 1, 
    ease: "none",
    immediateRender: true,
    motionPath: {
      path: "#path",
      align: "#path",
      alignOrigin: [0.5, 1],
      autoRotate: 0,
      start: 0.19,
      end: 0.81
    },
    onUpdate: function() {
      var progress = tl.progress(); 
      //console.log(progress);
      if(progress === 0.5) { 
        tl.removePause("0.5");
        tl.removePause("0.5");
      }
    }
  });

  tl.pause(0);

  jQuery("#play1").click(function(){
    jQuery(".slider-pagination-boat").removeClass('active');
    jQuery(this).addClass('active');

    if(tl.progress() != 0) { 
      tl.reversed( true );
      tl.resume();
    }
    swiper_home.slideTo(0);
  });

  jQuery("#play2").click(function(){
    jQuery(".slider-pagination-boat").removeClass('active');
    jQuery(this).addClass('active');

    tl.addPause("0.5");
    
    if(tl.progress() < 0.5) { 
      tl.reversed( false );
      tl.resume();
    }
    if(tl.progress() > 0.5) { 
      tl.reversed( true );
      tl.resume();
    }
    swiper_home.slideTo(1);
  });

  jQuery("#play3").click(function(){
    jQuery(".slider-pagination-boat").removeClass('active');
    jQuery(this).addClass('active');

    if(tl.progress() != 1) { 
      tl.reversed( false ); 
      tl.resume();
    }
    swiper_home.slideTo(2);
  });
}


AOS.init();